import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { mockData } from '../data/mock';

const Footer = () => (
  <footer className="bg-gradient-to-b from-[#0B1224] to-navy text-white py-14 border-t-2 border-gold/40 relative overflow-hidden">
    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] bg-[radial-gradient(ellipse,rgba(184,155,92,0.12)_0%,transparent_60%)] pointer-events-none" />
    <div className="container mx-auto px-6 relative z-10">
      <div className="grid md:grid-cols-3 gap-10 mb-10">
        <div>
          <h3 className="font-serif text-2xl font-bold mb-3 text-gold">Queensland Ranch</h3>
          <p className="text-white/70 leading-relaxed text-sm max-w-xs">
            A private luxury estate for unforgettable weddings, quinceañeras, and celebrations in Anthony, New Mexico.
          </p>
        </div>
        <div>
          <p className="text-gold text-xs tracking-[0.25em] uppercase mb-4">Explore</p>
          <ul className="space-y-2 text-sm">
            {[
              ['/weddings', 'Weddings'],
              ['/quinceaneras', 'Quinceañeras'],
              ['/events', 'Events'],
              ['/gallery', 'Gallery'],
              ['/about', 'About'],
              ['/contact', 'Check Availability'],
            ].map(([to, label]) => (
              <li key={to}>
                <Link to={to} className="text-white/70 hover:text-gold transition-colors">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-gold text-xs tracking-[0.25em] uppercase mb-4">Contact</p>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2">
              <Phone className="h-4 w-4 text-gold mt-0.5" />
              <a href={`tel:${mockData.contact.phone}`} className="hover:text-gold">{mockData.contact.phone}</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="h-4 w-4 text-gold mt-0.5" />
              <a href={`mailto:${mockData.contact.email}`} className="hover:text-gold break-all">{mockData.contact.email}</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 text-gold mt-0.5" />
              <span>{mockData.contact.address}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gold/30 pt-6 text-center text-slate-400 text-sm">
        <p>&copy; {new Date().getFullYear()} Queensland Ranch. All rights reserved.</p>
        <p className="mt-2 text-xs">
          <Link to="/qr" className="hover:text-gold transition-colors" data-testid="footer-qr-link">
            View / Print QR Code
          </Link>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
